import { useTenantContext } from '../context/TenantProvider';

/** The brand text names: the tenant of this domain. */
export function useBrandName() {
  return useTenantContext()?.tenant?.name ?? 'MyFitWorld';
}

/** The same brand where only a few letters fit: a badge, a tab. */
export function useBrandShortName() {
  const fullName = useBrandName();
  return useTenantContext()?.tenant?.shortName || fullName;
}
